import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "cookie-dlg",
  id: "cookie-settings-dlg"
}
const _hoisted_2 = { class: "d-flex flex-row" }
const _hoisted_3 = { class: "flex-grow-1" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createStaticVNode("<div data-v-19b272be><b data-v-19b272be>We use the following cookies on our web site:</b><br data-v-19b272be><ol data-v-19b272be><li data-v-19b272be>Authentication cookies which are required for the site functionality.</li><li id=\"ga-opted-in\" data-v-19b272be>Google Analytics cookies which are not personally identifiable. <span class=\"d-inline-block\" id=\"ga-opted-in\" data-v-19b272be>You can <a class=\"inline-link\" href=\"javascript:void(0)\" id=\"btn-cookie-ga-opt-out\" data-v-19b272be>opt out from using them</a>. </span></li><li id=\"ga-opted-out\" class=\"d-none\" data-v-19b272be>Google Analytics cookies. You opted out from using Google Analytics on this site. <a class=\"inline-link\" href=\"javascript:void(0)\" id=\"btn-cookie-ga-opt-in\" data-v-19b272be>Opt in again?</a>. </li></ol></div>", 1)),
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_3, [
          _cache[0] || (_cache[0] = _createTextVNode("By clicking \"I agree\" button you express your consent to store cookies in accordance with ", -1)),
          _createElementVNode("a", {
            href: _ctx.routes.ABOUT_PRIVACY,
            target: "_blank"
          }, "Privacy Policy", 8, _hoisted_4),
          _cache[1] || (_cache[1] = _createTextVNode(".", -1))
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("button", {
          class: "btn btn-outline-dark btn-sm",
          id: "btn-cookie-consent"
        }, "I Agree", -1))
      ])
    ])
  ]))
}